











































































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import NoAccountMessage from "@/employee/components/NoAccountMessage.vue";
import { formatCurrency } from "@/shared/currency";
import moment from "moment";
import _ from "lodash";
import {
  FundingOption,
  EligibilityStatus
} from "@/shared/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useHsaStore } from "@/shared/store/hsa";
import { usePartnerPortalStore } from "@/employee/store/partnerPortal";
import { useHsaLimitStore } from "@/shared/store/hsalimit";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Button,
    NoAccountMessage,
    GenericLoadingSpinner
  }
})
export default class PayrollOneTimeContributionForm extends Vue {
  $validator: Validator;

  hsaTotalStore = useHsaTotalStore();
  hsaStore = useHsaStore();
  partnerPortalStore = usePartnerPortalStore();
  hsaLimitStore = useHsaLimitStore();
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();

  proposedContribution = 0;
  isFormEditMode = false;
  formatCurrency = formatCurrency;
  isSubmitting = false;

  mounted (): void {
    this.hsaLimitStore.getHsaAccountLimits();
    if (!this.hsaTotalStore.isLoaded) {
      this.hsaTotalStore.getUserPayrollSummary();
    }
    this.hsaStore.loadTransactionTotals({ year: moment().year() });
    this.partnerPortalStore.getPartnerPortalStatus();
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  onSubmit (): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (this.isSubmitting) {
      return;
    }
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }
          this.isSubmitting = true;
          this.submitPayrollLift(this.proposedContribution);
        });
  }

  submitPayrollLift (amount): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    this
        .hsaTotalStore.updateOneTimeLiftContribution(amount)
        .then(response => {
          this.isFormEditMode = false;
          this.isSubmitting = false;
        });
  }

  cancelPayrollLift (): void {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    this.hsaTotalStore.updateOneTimeLiftContribution(0)
        .then(response => {
          this.isFormEditMode = true;
        });
  }

  get buttonTitle (): string {
    return this.isSubmitting ? "Processing..." : "Update";
  }

  get showNoAccountMessage (): boolean {
    return !this.partnerPortalStore.hasPortalAccess && !this.showLoading;
  }

  get showLoading (): boolean {
    return !this.hsaTotalStore.isLoaded;
  }

  get disableSubmit (): boolean {
    if (this.portalFunctionalityDisabled) {
      return true;
    }

    return this.disableProposedContribution ||
        this.$validator.errors.any() ||
        this.isSubmitting;
  }

  get disableProposedContribution (): boolean {
    return this.isOneTimeLiftLocked;
  }

  get isOneTimeLiftLocked (): boolean {
    if (this.portalFunctionalityDisabled) {
      return true;
    }

    return this.hsaTotalStore.oneTimeLift.isOneTimeLiftLocked;
  }

  get upcomingRecurringContribution (): number {
    return this.hsaTotalStore.nextEligiblePayPeriodAmount || 0;
  }

  get allowPayrollContribution (): boolean {
    return this.hsaTotalStore.allowPayrollContributions && this.hsaTotalStore.eligibilityStatus ===
        EligibilityStatus.Eligible
        && this.partnerPortalStore.hasPortalAccess && this.isBendFundingOption;
  }

  get isBendFundingOption (): boolean {
    return this.userStore.employeeFundingOption === FundingOption.BendCalculatePull;
  }

  get effectivePayDate (): string {
    return moment(this.hsaTotalStore.oneTimeLift.payDate).format("MMMM Do YYYY");
  }

  get revisedAmount (): number {
    return this.proposedContribution + this.upcomingRecurringContribution;
  }

  get showExistingLift (): boolean {
    return this.hsaTotalStore.isLoaded && !this.isFormEditMode && this.hasNextLiftAmount;
  }

  get showInputForm (): boolean {
    return !this.showExistingLift && !this.showLoading;
  }

  changeToEditMode (): void {
    this.isFormEditMode = true;
  }

  get contributionStoreNextLift (): number {
    if (this.hsaTotalStore.isLoaded) {
      return this.hsaTotalStore.oneTimeLift.amount || 0;
    }
    return 0;
  }

  get hasNextLiftAmount (): boolean {
    return this.contributionStoreNextLift > 0;
  }

  get validateProposedContribution (): any {
    const minimum = 0;
    const maximum = this.maximumRemainingPayrollContribution;

    return {
      required: true,
      decimal: 2,
      min_value_usd: minimum,
      max_value_usd: maximum
    };
  }

  // Max lift is the contribution total remaining contribution, plus any existing lift amount
  get maximumRemainingPayrollContribution (): number {
    return _.floor(this.hsaTotalStore.maximumRemainingContribution + this.hsaTotalStore.oneTimeLift.amount, 2);
  }

}
